export const common = {
  // Navigation
  'nav.features': 'Recursos',
  'nav.howItWorks': 'Como funciona',
  'nav.pricing': 'Preços',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'Sobre nós',
  'nav.getStarted': 'Começar',

  // About Us Section
  'aboutUs.badge': 'Sobre nós',
  'aboutUs.title': 'Sobre nós',
  'aboutUs.line1': 'Ideias são baratas.',
  'aboutUs.line2': 'Capital não. Tempo ainda menos.',
  'aboutUs.paragraph1': 'IdeaOracle.ai foi fundada porque a maioria das ideias de negócio não falha por falta de coragem – mas por falta de honestidade. Demasiada validação. Pouca realidade.',
  'aboutUs.belief1a': 'Não acreditamos em exageros.',
  'aboutUs.belief1b': 'Acreditamos na lógica do mercado.',
  'aboutUs.belief2a': 'Não acreditamos em motivação.',
  'aboutUs.belief2b': 'Acreditamos na procura, concorrência e diferenciação.',
  'aboutUs.mission1': 'A nossa tarefa não é fazer as ideias parecerem boas.',
  'aboutUs.mission2': 'A nossa tarefa é revelar a sua viabilidade.',
  'aboutUs.analysis': 'IdeaOracle.ai analisa nichos de negócio quanto à mecânica estrutural do mercado, procura realista, intensidade competitiva e viabilidade. Não emocional. Não otimista. Mas sóbrio.',
  'aboutUs.failure1': 'A maioria das ideias falha.',
  'aboutUs.failure2': 'Não porque os fundadores sejam incapazes –',
  'aboutUs.failure3': 'mas porque ninguém foi claro o suficiente antes.',
  'aboutUs.clarity': 'Existimos para fornecer essa clareza.',
  'aboutUs.value1': 'Desconfortável.',
  'aboutUs.value2': 'Direto.',
  'aboutUs.value3': 'Consistente.',
  'aboutUs.confirm': 'Se uma ideia tem substância, confirmamos.',
  'aboutUs.deny': 'Se não, também o dizemos.',
  'aboutUs.noApplause': 'Sem aplausos.',
  'aboutUs.noSugarcoating': 'Sem embelezamento.',
  'aboutUs.noTheater': 'Sem teatro.',

  // Hero Section
  'hero.badge': 'IA de decisão para nichos de negócio',
  'hero.title1': 'Ideias são baratas.',
  'hero.title2': 'Más decisões não são.',
  'hero.subtitle': 'Uma IA que avalia seu nicho de negócio',
  'hero.subtitleLine2': 'antes de você investir.',
  'hero.cta': 'Verificar ideia',
  'hero.ctaSecondary': 'Como funciona',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Créditos por solicitação',
  'hero.stat2Value': 'A partir de 7',
  'hero.stat2Label': 'Níveis de avaliação',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Honesto e Privado',

  // Features Section
  'features.title1': 'Recursos poderosos para',
  'features.title2': 'empresas',
  'features.title3': 'modernas',
  'features.honestVerdict.title': 'Veredicto honesto, não um score hype',
  'features.honestVerdict.description': 'Veredictos bom/médio/fraco diretos, baseados em dados de mercado reais e pesquisa de concorrentes. Nenhuma nota 9/10 feita para agradar cada ideia.',
  'features.fullJourney.title': 'Do teste de ideia ao Builder Report',
  'features.fullJourney.description': 'Valide no chat, aprofunde a análise de mercado, exporte um Builder Report de 25–75 páginas com personas, finanças, go-to-market e pitch deck.',
  'features.multilingual.title': '21 idiomas, dados de mercado locais',
  'features.multilingual.description': 'Da PME suíça ao fundador solo em São Paulo — a IA responde no seu idioma, com fontes do seu mercado.',

  // How It Works
  'howItWorks.title': 'Como funciona',
  'howItWorks.subtitle': 'Quatro passos para clareza sobre o seu nicho de negócios.',
  'howItWorks.step1Title': 'Escolher um plano',
  'howItWorks.step1Desc': 'Starter, Pro ou Builder – dependendo da profundidade da sua revisão.',
  'howItWorks.step2Title': 'Perguntar à IA',
  'howItWorks.step2Desc': 'Faça suas perguntas sobre o nicho. Cada pedido custa 30 créditos.',
  'howItWorks.step3Title': 'Obter veredicto honesto',
  'howItWorks.step3Desc': 'A IA avalia: Bom, Médio ou Mau. Sem rodeios.',
  'howItWorks.step4Title': 'Tomar uma decisão',
  'howItWorks.step4Desc': 'Agora você sabe se vale a pena seguir em frente.',

  // Pricing
  'pricing.title': 'Preços',
  'pricing.subtitle': 'Escolha o plano que se adequa à profundidade da sua revisão.',
  'pricing.yearlyDiscount': 'Assinatura anual:',
  'pricing.yearlyDiscountValue': '-20% de desconto',
  'pricing.perMonth': 'por mês',
  'pricing.selectPlan': 'Selecionar plano',
  'pricing.mostPopular': 'Mais popular',
  'pricing.footer': 'Todos os preços em CHF. Os créditos são deduzidos apenas para respostas IA bem-sucedidas.',
  
  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': 'Para testes de realidade iniciais.',
  'pricing.starter.credits': '2.500 créditos',
  'pricing.starter.feature1': 'Gerar ideia de nicho',
  'pricing.starter.feature2': 'Refinar nicho',
  'pricing.starter.feature3': 'Verificação de realidade do mercado',
  'pricing.starter.feature4': 'Avaliação da concorrência',
  'pricing.starter.feature5': 'Avaliação de timing',
  'pricing.starter.feature6': 'Veredicto honesto',
  'pricing.starter.feature7': 'Sessões privadas',
  'pricing.starter.feature8': 'Histórico e exportação',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'Para revisão mais profunda.',
  'pricing.pro.credits': '5.000 créditos',
  'pricing.pro.feature1': 'Todos os recursos Starter',
  'pricing.pro.feature2': 'Mais créditos para revisão intensiva',
  'pricing.pro.feature3': 'Sugestões de melhoria',
  'pricing.pro.feature4': 'Nichos alternativos',
  'pricing.pro.feature5': 'Análise de mercado detalhada',
  'pricing.pro.feature6': 'Suporte prioritário',
  'pricing.pro.feature7': 'Filtros avançados',
  'pricing.pro.feature8': 'Favoritos de sessão',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'Ideia → Briefing para desenvolvedores.',
  'pricing.builder.credits': 'Créditos ilimitados',
  'pricing.builder.feature1': 'Todos os recursos Pro',
  'pricing.builder.feature2': 'Pedidos IA ilimitados',
  'pricing.builder.feature3': 'Modo Builder: Briefing para desenvolvedores',
  'pricing.builder.feature4': 'Visão geral estruturada do projeto',
  'pricing.builder.feature5': 'Fluxos de usuário e funções principais',
  'pricing.builder.feature6': 'Notas técnicas',
  'pricing.builder.feature7': 'Definir não-objetivos',
  'pricing.builder.feature8': 'Limite de taxa de uso justo',
  'pricing.builder.limitNote': 'Limite de uso justo',
  'pricing.monthlyReset': 'Reinício mensal',

  // Modal
  'pricing.modal.selected': 'selecionado',
  'pricing.modal.comingSoon': 'O registo e processamento de pagamentos estarão disponíveis em breve.',
  'pricing.modal.patience': 'Estamos a trabalhar para lhe oferecer uma experiência segura e fluida. Por favor, tenha paciência.',
  'pricing.modal.understood': 'Compreendido',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Respondido honesta e criticamente.',
  'faq.q1': 'O que faz concretamente o IdeaOracle.ai?',
  'faq.a1': 'O IdeaOracle.ai avalia ideias de negócio e nichos quanto à lógica de mercado, procura real, concorrência, diferenciação e viabilidade.\nSe houver substância, mostramos como pode ser afinada estrategicamente.\nSe não, dizemos.',
  'faq.q2': 'Também geram ideias?',
  'faq.a2': 'Sim.\nMas não às cegas.\nDesenvolvemos abordagens com base na lógica de mercado – não em motivação ou tendências.',
  'faq.q3': 'Otimizam modelos de negócio?',
  'faq.a3': 'Sim – se existir potencial.\nNão polimos ilusões.\nTornamos conceitos viáveis mais resistentes.',
  'faq.q4': 'O que vos distingue de outras ferramentas de IA?',
  'faq.a4': 'Outras ferramentas fornecem inspiração.\nNós fornecemos avaliação.\nO foco está no realismo, não no entusiasmo.',
  'faq.q5': 'É uma garantia de sucesso?',
  'faq.a5': 'Não.\nReduzimos más decisões – não eliminamos o risco.',
  'faq.q6': 'Para quem é o IdeaOracle.ai?',
  'faq.a6': 'Fundadores antes do lançamento\nEmpreendedores antes da expansão\nSide-builders antes do investimento de tempo\nInvestidores antes da avaliação\n\nEm resumo: Para pessoas que querem clareza antes do capital.',
  'faq.q7': 'E se eu só procurar validação?',
  'faq.a7': 'Então o IdeaOracle.ai não é a ferramenta certa.',
  'faq.q8': 'Quão honesta é a análise?',
  'faq.a8': 'Tão honesta quanto os dados e a mecânica de mercado permitem.\nSem euforia. Sem clemência.',
  'faq.q9': 'Substituem a pesquisa de mercado?',
  'faq.a9': 'Não.\nSomos uma pré-avaliação estratégica – não um estudo de mercado completo.',
  'faq.q10': 'Porquê tão intransigentes?',
  'faq.a10': 'Porque fracassar é caro.\nA honestidade não.',

  // Footer
  'footer.description': 'Esta plataforma não o ajuda a sentir-se bem – mas a decidir corretamente.',
  'footer.product': 'Produto',
  'footer.aiAssistant': 'Assistente IA',
  'footer.howItWorks': 'Como funciona',
  'footer.pricing': 'Preços',
  'footer.faq': 'FAQ',
  'footer.legal': 'Legal',
  'footer.privacy': 'Privacidade',
  'footer.terms': 'Termos',
  'footer.imprint': 'Impressão',
  'footer.support': 'Suporte',
  'footer.contact': 'Contacto',
  'footer.documentation': 'Documentação',
  'footer.copyright': '© 2025 IdeaOracle.ai. Todos os direitos reservados.',

  // AI Assistant
  'aiAssistant.title': 'Assistente IA de nicho',
  'aiAssistant.subtitle': 'Perguntas sobre nichos',
  'aiAssistant.welcomeMessage': 'Olá! Descreva a sua ideia ou pergunte-me sobre um nicho. Darei uma avaliação clara e honesta.',
  'aiAssistant.demoResponse': 'Esta é uma demonstração. Para obter avaliações IA reais, registe-se e escolha um plano.',
  'aiAssistant.placeholder': 'Descreva a sua ideia...',

  // Header & Sidebar
  'dashboard.header.title': 'Painel',
  'dashboard.sidebar.overview': 'Visão geral',
  'dashboard.sidebar.newAnalysis': 'Assistente IA',
  'dashboard.sidebar.history': 'Histórico',
  'dashboard.sidebar.credits': 'Créditos',
  'dashboard.sidebar.settings': 'Configurações',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Bem-vindo de volta, {{name}}',
  'dashboard.overview.subtitle': 'Aqui está uma visão rápida da sua atividade',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Créditos restantes',
  'dashboard.stats.totalAnalyses': 'Análises totais',
  'dashboard.stats.goodRatings': 'Avaliações positivas',
  'dashboard.stats.nextReset': 'Próximo reset em',
  'dashboard.stats.days': 'dias',

  // Quick Actions
  'dashboard.quickActions.title': 'Ações rápidas',
  'dashboard.quickActions.checkNewIdea': 'Verificar uma ideia',
  'dashboard.quickActions.checkNewIdeaDesc': 'Analisar uma ideia de negócio existente',
  'dashboard.quickActions.generateIdea': 'Gerar uma ideia',
  'dashboard.quickActions.generateIdeaDesc': 'Encontrar um novo nicho rentável',
  'dashboard.quickActions.builderBriefing': 'Briefing Builder',
  'dashboard.quickActions.builderBriefingDesc': 'Transformar uma ideia num briefing pronto para desenvolvedores',
  'dashboard.quickActions.premiumOnly': 'Apenas Builder',

  // Chat Header
  'chat.title': 'Assistente IA de nicho',
  'chat.subtitle': 'Faça perguntas sobre nichos. Avalio de forma crítica e honesta.',
  'chat.creditsLabel': 'Créditos',

  // Chat Welcome
  'chat.welcomeTitle': 'Bem-vindo ao Assistente IA de nicho',
  'chat.welcomeDesc': 'Descreva a sua ideia ou pergunte sobre um nicho. Avaliarei honestamente: Bom, Médio ou Mau.',
  'chat.aiWelcome': 'Olá! Descreva a sua ideia ou pergunte-me sobre um nicho. Darei uma avaliação clara e honesta.',

  // Chat Suggestions
  'chat.suggestion1': 'Encontre-me um nicho rentável.',
  'chat.suggestion2': 'Tenho uma ideia – avalie-a honestamente.',
  'chat.suggestion3': 'Que nichos têm potencial agora?',
  'chat.suggestion4': 'Refine este nicho e torne-o mais específico.',

  // Chat Actions
  'chat.newConversation': 'Nova conversa',
  'chat.today': 'Hoje',
  'chat.yesterday': 'Ontem',
  'chat.thisWeek': 'Esta semana',
  'chat.thisMonth': 'Este mês',
  'chat.older': 'Mais antigo',
  'chat.messages': 'mensagens',
  'chat.renameConversation': 'Renomear',
  'chat.deleteConversation': 'Eliminar',
  'chat.cancel': 'Cancelar',
  'chat.rename': 'Renomear',
  'chat.delete': 'Eliminar',
  'chat.favorite': 'Adicionar favorito',
  'chat.unfavorite': 'Remover favorito',
  'chat.searchSessions': 'Pesquisar conversas...',
  'chat.noResults': 'Nenhum resultado encontrado',
  'chat.noSessions': 'Ainda não há conversas',
  'chat.enterNewName': 'Introduza um novo nome...',
  'chat.deleteConfirmMessage': 'Tem a certeza de que deseja eliminar esta conversa? Esta ação não pode ser desfeita.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Digite a sua pergunta… (custa 30 créditos)',
  'chat.send': 'Enviar',
  'chat.voice': 'Falar',
  'chat.listeningPlaceholder': 'Estou a ouvir... Fale agora.',
  'chat.stopListening': 'Parar gravação',
  'chat.recording': 'A gravar...',
  'chat.speechNotSupported': 'O reconhecimento de voz não é suportado pelo seu navegador.',
  'chat.microphonePermissionDenied': 'O acesso ao microfone foi negado. Por favor, permita o acesso nas configurações do seu navegador.',
  'chat.errorNotEnoughCredits': 'Créditos insuficientes. Por favor, atualize o seu plano ou aguarde o próximo reset.',
  'chat.errorAiFailed': 'A resposta IA falhou. Nenhum crédito foi deduzido.',
  'chat.errorRateLimit': 'Demasiados pedidos. Por favor, aguarde um momento.',

  // Ratings
  'rating.good': 'Bom',
  'rating.medium': 'Médio',
  'rating.bad': 'Mau',

  // Auth Page
  'auth.branding.headline1': 'Nem todas as ideias são boas.',
  'auth.branding.headline2': 'Dizemos-lhe honestamente.',
  'auth.branding.subtitle': 'Uma IA de decisão para nichos de negócios. Clara. Crítica. Sem rodeios.',
  'auth.benefits.privacy.title': '100% Privado',
  'auth.benefits.privacy.desc': 'As suas ideias permanecem completamente privadas e seguras.',
  'auth.benefits.honest.title': 'IA Honesta',
  'auth.benefits.honest.desc': 'Sem rodeios – apenas feedback claro e crítico.',
  'auth.benefits.fast.title': 'Resultados Rápidos',
  'auth.benefits.fast.desc': 'Obtenha clareza sobre o seu nicho em minutos.',
  'auth.trust.users': 'Utilizadores Ativos',
  'auth.trust.ideas': 'Ideias Analisadas',
  'auth.trust.rating': 'Avaliação',
  'auth.login.title': 'Entrar',
  'auth.login.headline': 'Bem-vindo de volta',
  'auth.login.subtitle': 'Entre para continuar a sua jornada.',
  'auth.login.forgotPassword': 'Esqueceu a palavra-passe?',
  'auth.login.submit': 'Entrar',
  'auth.login.noAccount': 'Ainda não tem conta?',
  'auth.login.signUp': 'Registar-se',
  'auth.register.title': 'Registar',
  'auth.register.headline': 'Crie a sua conta',
  'auth.register.subtitle': 'Comece a analisar as suas ideias de negócio hoje.',
  'auth.register.submit': 'Criar Conta',
  'auth.register.hasAccount': 'Já tem uma conta?',
  'auth.register.signIn': 'Entrar',
  'auth.fields.name': 'Nome Completo',
  'auth.fields.email': 'Endereço de Email',
  'auth.fields.password': 'Palavra-passe',
  'auth.fields.confirmPassword': 'Confirmar Palavra-passe',
  'auth.fields.selectPlan': 'Selecione o seu plano',
  'auth.placeholders.name': 'Introduza o seu nome',
  'auth.placeholders.email': 'Introduza o seu email',
  'auth.placeholders.password': 'Introduza a sua palavra-passe',
  'auth.placeholders.confirmPassword': 'Confirme a sua palavra-passe',
  'auth.terms.accept': 'Aceito os',
  'auth.terms.terms': 'Termos e Condições',
  'auth.privacy.accept': 'Aceito a',
  'auth.privacy.policy': 'Política de Privacidade',
  'auth.errors.nameRequired': 'O nome é obrigatório',
  'auth.errors.emailRequired': 'O email é obrigatório',
  'auth.errors.emailInvalid': 'Por favor introduza um email válido',
  'auth.errors.passwordRequired': 'A palavra-passe é obrigatória',
  'auth.errors.passwordLength': 'A palavra-passe deve ter pelo menos 8 caracteres',
  'auth.errors.passwordMismatch': 'As palavras-passe não coincidem',
  'auth.loading': 'Por favor aguarde...',
  'auth.or': 'ou continuar com',
  'auth.social.google': 'Continuar com Google',
  'auth.social.apple': 'Continuar com Apple',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': 'Acesso gratuito de 3 dias',
  'pricing.trial.credits': '250 créditos',
  'pricing.trial.free': 'Grátis',
  'pricing.trial.duration': 'Sem custos durante 3 dias',
  'pricing.trial.cta': 'Iniciar teste gratuito',
  'pricing.trial.feature1': '250 créditos para explorar a IA',
  'pricing.trial.feature2': 'Acesso completo durante 3 dias',
  'pricing.trial.feature3': 'Sem cartão de crédito',
  'pricing.trial.feature4': 'Cancele quando quiser',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10.000 créditos + relatório Builder de 25 páginas',
  'pricing.gold.credits': '10.000 créditos',
  'pricing.gold.feature1': '10.000 créditos',
  'pricing.gold.feature2': 'Relatório Builder de 25 páginas',
  'pricing.gold.feature3': 'Todas as funcionalidades Starter e Pro',
  'pricing.gold.feature4': 'Análise de mercado e resumo',
  'pricing.gold.feature5': 'Oportunidades, riscos, recomendações',
  'pricing.gold.feature6': 'Baixar PDF',
  'pricing.gold.feature7': 'Suporte',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15.000 créditos + relatório Builder de 100 páginas',
  'pricing.platinum.credits': '15.000 créditos',
  'pricing.platinum.feature1': '15.000 créditos',
  'pricing.platinum.feature2': 'Relatório Builder de 100 páginas',
  'pricing.platinum.feature3': 'Todas as funcionalidades Gold',
  'pricing.platinum.feature4': 'Modo Builder: briefings para desenvolvedores',
  'pricing.platinum.feature5': 'Resumo estruturado',
  'pricing.platinum.feature6': 'Análise de mercado avançada',
  'pricing.platinum.feature7': 'Suporte',

  // Pricing UI
  'pricing.monthly': 'Mensal',
  'pricing.yearly': 'Anual',
  'pricing.savings': 'de economia',
  'pricing.billedYearly': 'Cobrança anual',

  // Hero trial CTA
  'hero.trialTitle': 'Comece o seu teste gratuito',
  'hero.creditsLabel': 'Créditos',
  'hero.trialTagline': 'Experimente o nosso assistente de IA grátis por 3 dias',
  'hero.trialCta': 'Registe-se e receba 250 créditos',
  'hero.trialNoCard': 'Sem cartão de crédito. Sem compromisso.',

  // Admin
  'admin.dashboard.tabs.plans': 'Planos',

  // Credit top-up
  'dashboard.credits.topup.button': 'Recarregar créditos',
  'dashboard.credits.topup.buttonTitle': 'Compre mais créditos sem mudar de plano',
  'dashboard.credits.topup.title': 'Recarregar créditos',
  'dashboard.credits.topup.subtitle': 'CHF 0,15 por crédito — sem mudança de plano',
  'dashboard.credits.topup.quickAmounts': 'Seleção rápida',
  'dashboard.credits.topup.custom': 'Personalizado',
  'dashboard.credits.topup.totalLabel': 'Total',
  'dashboard.credits.topup.creditsLabel': 'Créditos',
  'dashboard.credits.topup.confirm': 'Comprar agora',
  'footer.disclaimer': 'Aviso legal',
  'legal.backToHome': 'Voltar ao início',
  'legal.lastUpdated': 'Última atualização',
  'legal.allRightsReserved': 'Todos os direitos reservados.',
  'legal.authoritativeNotice': 'Uma versão localizada no seu idioma ainda não está disponível. O texto autoritativo em inglês é mostrado abaixo.',
  'legal.translationNotice': 'Esta é uma tradução de cortesia. A versão em inglês é o original juridicamente vinculativo.',
};

export default common;
